// Categories.js
import React from "react";

const Categories = ({ filterItems, categories }) => {
  return (
    <div className="row">
      <div className="col-lg-12 d-flex justify-content-center">
        <ul id="portfolio-flters">
          {categories.map((category, index) => (
            <li key={index} onClick={() => filterItems(category)} className="filter-active">
              {category}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Categories;
